<template>
    <el-upload
     :disabled="disabled"
     :action="fileUploadUrl"
     :headers="myHeaders"
     :on-success="uploadSuccess"
     :before-upload="beforeUpload"
     :on-progress="progressUpload"
     :show-file-list="false">
     <el-tooltip content="上传文件" placement="top" effect="light">
        <span class="fileIcon"></span>
     </el-tooltip>
    </el-upload>
</template>
<script>
import Operation from "@/request"

export default {
    props: ['fileUploadSuccess'],
    data() {
        return {
            myHeaders: "",
            fileUploadUrl: "",
            disabled: false
        }
    },
    created() {
        this.getAvatarUploadUrl();
    },
    methods: {
        //拼接头像上传地址
        getAvatarUploadUrl(){
            let token = Operation.SessionStorage.get('token')
            this.myHeaders = { token: token }
            this.fileUploadUrl = Operation.Const.ApiUrl + "/upload";
        },
        //上传验证
        beforeUpload(file){
            console.log(file)
            if(file.size > 104857600) {
                this.$message({
                    message: '文件大小不能超过100M',
                    type: 'warning'
                });
                return false;
            }
            this.disabled = true;
            this.$emit('startFileUpload', file.name);
            // this.$message('文件开始上传');
        },
        progressUpload(event, file, fileList) {
            console.log(event, file, fileList)
            this.$emit('setFileProgressBar', Math.floor(event.percent))
        },
        //文件上传成功
        uploadSuccess(response, file, fileList) {
            if(response) {
                this.disabled = false;
                this.$emit('fileUploadSuccess', response, file.name);
                this.$message({
                    message: '上传成功',
                    type: 'success'
                });
            }
        },
    }
}
</script>
<style scoped>
.fileIcon {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 0 2px;
    background-image: url(~@/assets/tic/file.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/fileUpload.vue